// Utility function
const Util = {

  /*
    Class manipulation functions
  */
  hasClass (el, className) {
    if (el.classList) return el.classList.contains(className);
    // else return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
    else return !!el.getAttribute('class').match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
  },

  addClass (el, className) {
    var classList = className.split(' ');
    if (el.classList) el.classList.add(classList[0]);
    else if (!this.hasClass(el, classList[0])) {
      // el.className += " " + classList[0];
      var c = el.getAttribute('class');
      el.setAttribute('class', c + " " + classList[0]);
    }
    if (classList.length > 1) this.addClass(el, classList.slice(1).join(' '));
  },

  removeClass (el, className) {
    var classList = className.split(' ');
    if (el.classList) el.classList.remove(classList[0]);
    else if(this.hasClass(el, classList[0])) {
        var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
        // el.className=el.className.replace(reg, ' ');
        var c = el.getAttribute('class');
        el.setAttribute('class', c.replace(reg, ' '))
    }
    if (classList.length > 1) this.removeClass(el, classList.slice(1).join(' '));
  },

  toggleClass (el, className, bool) {
    if (!el) return
    if(bool) this.addClass(el, className);
    else this.removeClass(el, className);
  },

  setAttributes (el, attrs) {
    for(var key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
  },

  /*
    DOM manipulation
  */
  getChildrenByClassName (el, className) {
    var children = el.children,
      childrenByClass = [];
    for (var i = 0; i < el.children.length; i++) {
      if (this.hasClass(el.children[i], className)) childrenByClass.push(el.children[i]);
    }
    return childrenByClass;
  },

  // Find a parent element by its tag
  findParentByTagName (element, tagName) {
    let parent = element
    while (parent !== null && parent.tagName !== tagName.toUpperCase()) {
      parent = parent.parentNode
    }
    return parent
  },

  // Animate height of an element
  setHeight (start, to, element, duration, cb) {
    var change = to - start,
        currentTime = null;

    var animateHeight = function(timestamp){
      if (!currentTime) currentTime = timestamp;
      var progress = timestamp - currentTime;
      var val = parseInt((progress/duration)*change + start);
      element.setAttribute("style", "height:"+val+"px;");
      if(progress < duration) {
          window.requestAnimationFrame(animateHeight);
      } else {
          cb();
      }
    };

    //set the height of the element before starting animation -> fix bug on Safari
    element.setAttribute("style", "height:"+start+"px;");
    window.requestAnimationFrame(animateHeight);
  },

  // Show or hide an element
  show ( element, style ) {
    if (style) {
      element.style.display = style
    } else {
      element.style.display = 'block'
    }
  },

  hide ( element ) {
    element.style.display = 'none'
  },

  isInViewport (elem, boundsToAdd = 0) {
    const scroll    = window.scrollY || window.pageYOffset
    const boundsTop = elem.getBoundingClientRect().top + scroll

    const viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight,
    }
    const bounds = {
      top: boundsTop,
      bottom: boundsTop + elem.clientHeight,
    }
    if ( boundsToAdd > 0 ) {
      bounds.top = bounds.top - ( elem.clientHeight * boundsToAdd )
      bounds.bottom = bounds.bottom + ( elem.clientHeight * boundsToAdd )
    }

    const inview = ( bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom )
      || ( bounds.top <= viewport.bottom && bounds.top >= viewport.top );

    // debug('inview')
    // debug(inview, elem)

    return inview;
  },

  /* Create element
  var el = Util.create({
    selector: 'div',
    id: 'the-el-id',
    attr: ['data-id' => 1]
    href: 'https://...',
    target: '_blank',
    src: 'https://...',
    class: 'preloader',
    html: '<span>Text</span>',
    children: DOMElements
  });
  */
  create(opt) {
    opt = opt || {};

    var el = document.createElement(opt.selector)

    if (opt.attr) for(var index in opt.attr) {
      opt.attr.hasOwnProperty(index) && el.setAttribute(index, opt.attr[index])
    }

    "a" == opt.selector && opt.link && (
      el.href = opt.link,
      opt.target && el.setAttribute("target", opt.target)
    )

    "img" == opt.selector && opt.src && (
      el.src = opt.src,
      opt.lazyload && (
        el.style.opacity = 0,
        el.onload = function() {
          el.style.opacity = 1
        }
      )
    )

    opt.id && (el.id = opt.id)
    opt.class && (el.className = opt.class)

    opt.html && (el.innerHTML = opt.html)
    opt.children && (el.appendChild(opt.children))

    return el;
  },

  /*
    Smooth Scroll
  */

  scrollTo (final, duration, cb) {
    var start = window.scrollY || document.documentElement.scrollTop,
        currentTime = null,
        speed = duration || 600;

    var animateScroll = function(timestamp){
      if (!currentTime) currentTime = timestamp;
      var progress = timestamp - currentTime;
      if(progress > speed) progress = speed;
      var val = Math.easeInOutQuad(progress, start, final - start, speed);
      window.scrollTo(0, val);
      if(progress < speed) {
          window.requestAnimationFrame(animateScroll);
      } else {
        cb && cb();
      }
    };

    window.requestAnimationFrame(animateScroll);
  },
  // scrollTo (final, duration, cb) {
  //   const start = window.scrollY || document.documentElement.scrollTop,
  //         speed = duration || 600
  //   let currentTime = 0

  //   const time = Math.max(0.1, Math.min(Math.abs(start - final) / speed, 0.8))

  //   debug(final)

  //   const tick = () => {
  //     currentTime += 1 / 60

  //     const p = currentTime / time
  //     const t = Math.easeOutCirc(p)

  //     if (p < 1) {
  //       requestAnimationFrame(tick)
  //       window.scrollTo(0, start + (final - start) * t)
  //     } else {
  //       window.scrollTo(0, 0)
  //       cb && cb()
  //     }
  //   }

  //   tick()
  // },

  scrollToTop (duration, cb) {
    this.scrollTo(0, duration, cb)
  },

  scrollZero () {
    window.scrollTo(0, 0)
  },

  getScrollY () {
    return window.pageYOffset || document.documentElement.scrollTop;
  },


  // Disable / enable Scroll

  preventDefault(e) {
    e.preventDefault();
  },

  preventDefaultForScrollKeys(e) {
    // left: 37, up: 38, right: 39, down: 40,
    // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
    var keys = {37: 1, 38: 1, 39: 1, 40: 1};

    if (keys[e.keyCode]) {
      this.preventDefault(e);
      return false;
    }
  },

  // call this to Disable scroll
  disableScroll() {
    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; }
      }));
    } catch(e) {}

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
    window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
  },

  // call this to Enable scroll
  enableScroll() {
    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; }
      }));
    } catch(e) {}

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    window.removeEventListener(wheelEvent, this.preventDefault, wheelOpt);
    window.removeEventListener('touchmove', this.preventDefault, wheelOpt);
    window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
  },


  /*
    Focus utility classes
  */

  // Move focus to an element
  moveFocus (element) {
    if( !element ) element = document.getElementsByTagName("body")[0];
    element.focus();
    if (document.activeElement !== element) {
      element.setAttribute('tabindex','-1');
      element.focus();
    }
  },

  /*
    Misc
  */

  getIndexInArray (array, el) {
    return Array.prototype.indexOf.call(array, el);
  },

  cssSupports (property, value) {
    if('CSS' in window) {
      return CSS.supports(property, value);
    } else {
      var jsProperty = property.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase();});
      return jsProperty in document.body.style;
    }
  },

  // Check if string is a correct email adress
  validateEmail (email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(email)
  },

  /**
   * {JSDoc}
   *
   * The splice() method changes the content of a string by removing a range of
   * characters and/or adding new characters.
   *
   * @this {String}
   * @param {number} start Index at which to start changing the string.
   * @param {number} delCount An integer indicating the number of old chars to remove.
   * @param {string} newSubStr The String that is spliced in.
   * @return {string} A new string with the spliced substring.
   */
  splice (string, start, delCount, newSubStr) {
    return string.slice(0, start) + newSubStr + string.slice(start + Math.abs(delCount))
  },

  /*
    Get window width and height
  */
  getWindowDimensions () {
    const w = window
    const d = document
    const e = d.documentElement
    const g = d.getElementsByTagName('body')[0]

    const x = w.innerWidth || e.clientWidth || g.clientWidth
    const y = w.innerHeight || e.clientHeight || g.clientHeight

    return {
      width: x,
      height: y
    }
  },

  /*
    Check if an url contains the site url
    => "site_url" is defined in the <head>
  */
  isSiteUrl (url) {
    return url.indexOf(site_url) === 0
  },

  /*
    Generate an icon
  */
  generateIcon (name, label = null) {
    const aria = label ? `aria-label="${label}"` : 'aria-hidden="true"'
    return `
      <span class="icon icon--${name}">
        <svg role="img" ${aria}>
          <use xlink:href="#${name}"></use>
        </svg>
      </span>
    `
    // <use xlink:href="${site_theme_url}/src/img/sprite.svg#${name}"></use>
  },

  // captureForm(form) {
  //     let field
  //     let i
  //     const s = {}

  //     if (typeof form === 'object' && form.nodeName === 'FORM') {
  //         const len = form.elements.length
  //         for (i = 0; i < len; i += 1) {
  //             field = form.elements[i]
  //             if (
  //                 field.name &&
  //                 !field.disabled &&
  //                 field.type !== 'file' &&
  //                 field.type !== 'reset' &&
  //                 field.type !== 'submit' &&
  //                 field.type !== 'button'
  //             ) {
  //                 s[field.name] = field.value || ''
  //             }
  //         }
  //     }
  //     return s
  // },

  // // serialize an object to a string
  // serialize(obj) {
  //     return Object.keys(obj)
  //         .reduce((a, k) => {
  //             a.push(`${k}=${encodeURIComponent(obj[k])}`)
  //             return a
  //         }, [])
  //         .join('&')
  // },

  /*
      Math
  */
  // Equation of a line.
  lineEq (y2, y1, x2, x1, currentVal) {
    var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
    return m * currentVal + b;
  },

  // Linear Interpolation function.
  lerp (a, b, n) {
    return (1 - n) * a + n * b;
  },

  // Number format
  number_format (number, decimals, decPoint, thousandsSep) { // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/number_format/
    // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: davook
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Brett Zamir (https://brett-zamir.me)
    // improved by: Theriault (https://github.com/Theriault)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // bugfixed by: Michael White (https://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (https://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (https://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
    //  revised by: Luke Smith (https://lucassmith.name)
    //    input by: Kheang Hok Chin (https://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (https://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56)
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ')
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '')
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.')
    //   returns 4: '67,00'
    //   example 5: number_format(1000)
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2)
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1)
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.')
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0)
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2)
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4)
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3)
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ')
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '')
    //  returns 14: '0.00000001'

    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''

    var toFixedFix = function (n, prec) {
      if (('' + n).indexOf('e') === -1) {
        return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
      } else {
        var arr = ('' + n).split('e')
        var sig = ''
        if (+arr[1] + prec > 0) {
          sig = '+'
        }
        return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
      }
    }

    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }

    return s.join(dec)
  }

}


/*
  Request Animations Frame helpers

  Usage :
  interval1 = window.rInterval( function() { console.log('interval1') }, 2000 );
  timeout1 = window.rtimeOut( function() { console.log('timeout1') }, 5000 );

  Clear :
  interval1.clear();
  timeout1.clear();
*/

window.rtimeOut = function( callback, delay ) {
 var  dateNow = Date.now,
      // requestAnimation = window.requestAnimationFrame,
      requestAnimation = (function () {
        return window.requestAnimationFrame || function (callback, element) {
          window.setTimeout(callback, 1000 / 60);
        };
      })(),
      start = new Date().getTime(),
      stop,
      timeoutFunc = function () {
        dateNow() - start < delay ? stop || requestAnimation(timeoutFunc) : callback()
      };

 requestAnimation(timeoutFunc);

 return {
  clear: function () { stop = 1 }
 }
}

window.rInterval = function ( callback, delay ) {
 var  dateNow = Date.now,
      // requestAnimation = window .requestAnimationFrame,
      requestAnimation = (function () {
        return window.requestAnimationFrame || function (callback, element) {
          window.setTimeout(callback, 1000 / 60);
        };
      })(),
      start = dateNow(),
      stop,
      intervalFunc = function () {
        dateNow() - start < delay || (start += delay, callback() );
        stop || requestAnimation(intervalFunc)
      };

 requestAnimation(intervalFunc);

 return {
  clear: function () { stop = 1 }
 }
}


/*
  Animation curves
*/
Math.easeInOutQuad = function (t, b, c, d) {
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
};

Math.easeOutCirc = function (pos) {
  return Math.sqrt(1 - Math.pow(pos - 1, 2))
};


/*
    Polyfills
*/
//Closest() method
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

//Custom Event() constructor
function CustomEvent ( event, params ) {
  params = params || { bubbles: false, cancelable: false, detail: undefined };
  var evt = document.createEvent( 'CustomEvent' );
  evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
  return evt;
}
if ( typeof window.CustomEvent !== "function" ) {
  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}

export default Util